import script from "./VDropzone.vue?vue&type=script&setup=true&lang=ts"
export * from "./VDropzone.vue?vue&type=script&setup=true&lang=ts"

import "./VDropzone.vue?vue&type=style&index=0&id=54f1f8fb&lang=scss"

const __exports__ = script;

export default __exports__